export default class Request {
  constructor() {
    this.req = new XMLHttpRequest();
  }

  get(url, callback) {
    let http = this.req;
    this.req.onreadystatechange = function(http = http) {
      if (this.readyState == 4) {
        let response = {statusCode: this.status, data: this.responseText}
        callback(http, response);          
      }
    }
    this.req.open("GET", url, true);
    this.req.send();
  }

  post(url, params, callback) {
    let http = this.req;
    http.onreadystatechange = function(http = http) {
      if (this.readyState == 4) {
        let response = {statusCode: this.status, data: this.responseText}
        callback(http, response);
      }
    }
    http.open("POST", url, true);
    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    http.send(params);
  }
}
